<template src="./templates/Filters.html" />

<script setup>

import { ref } from 'vue';
import {
    useCategoriesStore,
    useFacetsStore,
    useRegionsStore,
    useLocationsStore,
    useResultsStore,
    useQueryParamsStore,
    pageSettings,
    useClearFilters,
    useDatesStore,
} from '@timezoneone/dottie-client-jam';
import { config } from '../config/config.js';

import Categories from './Categories.vue';
import Date from './Date.vue';
import Facets from './Facets.vue';
import Keywords from './Keywords.vue';
import Locations from './Locations.vue';
import Regions from './Regions.vue';
import QuickFilters from './QuickFilters.vue';

const categoriesStore = useCategoriesStore();
const regionsStore = useRegionsStore();
const resultsStore = useResultsStore();
const facetsStore = useFacetsStore();
const queryParamsStore = useQueryParamsStore();
const locationsStore = useLocationsStore();
const datesStore = useDatesStore();

/* eslint-disable func-names */
const showFilters = function() {

    const filterDialog = document.getElementById('filter-dialog');
    filterDialog.showModal();

    // A hack to prevent the multiselect from autofocusing / opening the dropdown when dialog is opened
    const locationMultiselect = document.querySelector('.multiselect__input');
    if (locationMultiselect) {

        locationMultiselect.focus();
        locationMultiselect.blur();

    }

    filterDialog.addEventListener('click', () => {

        return filterDialog.close();

    });
    const filterContent = document.getElementById('filter-content');
    filterContent.addEventListener('click', (event) => {

        return event.stopPropagation();

    });

};

/* eslint-disable func-names */
const hideFilters = function() {

    document.getElementById('filter-dialog').close();

};

/* eslint-disable func-names */
const clearFilters = function() {

    useClearFilters(
        categoriesStore,
        regionsStore,
        facetsStore,
        queryParamsStore,
        locationsStore,
        datesStore,
    );

};

const isEventsPage = ref(false);

async function setIsEventsPage() {

    const settings = await pageSettings(config.metaId);

    if (settings.eventsPage) {

        isEventsPage.value = true;

    }

}

setIsEventsPage();

const hasQuickFilters = ref(false);

async function setHasQuickFilters() {

    const settings = await pageSettings(config.metaId);

    if (settings.quickFilters.length > 0) {

        hasQuickFilters.value = true;

    }

}

setHasQuickFilters();

</script>
